/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Models_Region_GlobalInputs */



/**
* | output |
* | --- |
* | "Global deployment" |
*
* @param {Org_Models_Region_GlobalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_models_region_global = /** @type {((inputs?: Org_Models_Region_GlobalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Models_Region_GlobalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Globale Bereitstellung")
	return /** @type {LocalizedString} */ ("Global deployment")
});